import { Session } from '@ais-ui/auth';

export const setSelectionData = async (
  session: Session,
  jobUuid: string,
  jsonData: string
): Promise<null> => {
  const response = await session.request('setSelectionData', {
    jobUuid: jobUuid,
    jsonData: jsonData,
  });

  return response;
};
